export default function formatNumberString(number){
    return new Intl.NumberFormat('de-DE').format(number)
}